import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router"
import styles from './CommonSettingList.module.css';
import { Layout, Table } from "antd";
import { AuthButton } from "../../core/CoreForm"
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from "../../core/CorePageContents"
import * as Module from "../../../modules/prime/commonSetting/commonSettingModule";
import * as Model from "../../../modules/prime/commonSetting/commonSettingModel";
import * as CONSTANTS from "../../../constants/constants";
import * as constantsUtils from '../../../utils/constantsUtils';
import { initMessages } from "../../../modules/core/commonMessageModule";
import AuthButtonStyles from "../../core/css/AuthButton.module.css";
import { storedLoginUserInfo } from "../../../modules/core/authModule";

interface titleInterface {
  title: string;
}

export const CommonSettingList = (props: titleInterface) => {

  const dispatch = useDispatch();
  let closingDateList = useSelector(Module.storedClosingClosingDateList);
  let workflowFlagList = useSelector(Module.storedWorkflowFlagList);
  let calcWorkTimeTypeList = useSelector(Module.storedCalcWorkTimeTypeList);
  let editabilityWorkTimeTypeList = useSelector(Module.storedEditabilityWorkTimeTypeList);
  let submitLevelTypeList = useSelector(Module.storedSubmitLevelTypeList);
  let attendancePerformanceDuplicateList = useSelector(Module.storedAttendancePerformanceDuplicateList);
  let mutualAidProjectGivingPointMethodList = useSelector(Module.storedMutualAidProjectGivingPointMethodList);
  let apportionmentTypeList = useSelector(Module.storedApportionmentTypeList);
  let storedPositionAuthorityList = useSelector(Module.storedPositionAuthorityList);
  let storedMailTypeSendFlagToPrimePositionAuthorityApproveUserList = useSelector(Module.storedMailTypeSendFlagToPrimePositionAuthorityApproveUserList);
  let storedMailTypeSendFlagToPrimePositionAuthorityConfirmUserList = useSelector(Module.storedMailTypeSendFlagToPrimePositionAuthorityConfirmUserList);
  let storedMailTypeSendFlagToPrimeSkillmapAuthorityApproveUserList = useSelector(Module.storedMailTypeSendFlagToPrimeSkillmapAuthorityApproveUserList);
  let storedMailTypeSendFlagToPartnerSubmitUserList = useSelector(Module.storedMailTypeSendFlagToPartnerSubmitUserList);
  let loginUserInfo = useSelector(storedLoginUserInfo);

  let history = useHistory();

  useEffect(() => {
    dispatch(Module.getPrimeCommonSettingAsync());
  }, []);


  /**
   * 編集ボタン押下時アクション
   */
  const editClicked = () => {
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_SETTING_EDIT);
  }


  /**
   * 締切設定の表示
   */
  const closingDateTableColumns = [
    {
      title: '締切',
      width: '250px',
      align: 'center' as 'center',
      render: (value: any, row: Model.ClosingDateRow) => {
        return (
          <>
            <span>{constantsUtils.getLabelOf(CONSTANTS.CLOSING_DATE_KBN, row.closingDateKbn)}</span>
          </>
        );
      },
    },
    {
      title: '期限',
      align: 'left' as 'left',
      render: (value: any, row: Model.ClosingDateRow) => {
        return (
          <>
            <span>
              {(row.closingMonth && row.closingDate) ? `${row.closingMonth} ヶ月後の ${row.closingDate} 日まで` : "設定なし"}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * ワークフローの表示
   */
  const workflowColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.WorkflowRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'flag',
      align: 'left' as 'left',
      render: (value: string, row: Model.WorkflowRow) => {
        return (
          <>
            <span>
              {row.flag == CONSTANTS.WORKFLOW_FLAG.ON.code ? "有効" : "無効"}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * 労働時間自動入力の表示
   */
  const calcWorkTimeColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.CalcWorkTimeRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'value',
      align: 'left' as 'left',
      render: (value: string, row: Model.CalcWorkTimeRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.CALC_WORK_TIME_TYPE, row.value)}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * 労働時間編集可否の表示
   */
  const editabilityWorkTimeColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.EditabilityWorkTimeRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'value',
      align: 'left' as 'left',
      render: (value: string, row: Model.EditabilityWorkTimeRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.EDITABILITY_WORK_TIME_TYPE, row.value)}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * 提出可能な協力会社の設定の表示
   */
  const submitLevelTypeColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.SubmitLevelRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'value',
      align: 'left' as 'left',
      render: (value: string, row: Model.SubmitLevelRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.SUBMIT_LEVEL_TYPE, row.value)}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * 勤怠重複有無の設定の表示
   */
  const attendancePerformanceDuplicateColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.AttendancePerformanceDuplicateRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'value',
      align: 'left' as 'left',
      render: (value: string, row: Model.AttendancePerformanceDuplicateRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.ATTENDANCE_PERFORMANCE_DUPLICATE, row.value)}
            </span>
          </>
        );
      },
    },
  ];


  /**
   * 基本設定の表示
   */
  const apportionmentTypeColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.CommonSettingRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'flag',
      align: 'left' as 'left',
      render: (value: string, row: Model.CommonSettingRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.APPORTIONMENT_TYPE, row.value)}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * 建退共連携時の同日複数現場の勤怠集約設定の表示
   * @returns
   */
  const mutualAidProjectGivingPointMethodColumns = [
    {
      title: '項目',
      width: '250px',
      dataIndex: 'label',
      align: 'center' as 'center',
      render: (value: any, row: Model.CommonSettingRow) => {
        return (
          <>
            <span>{row.label}</span>
          </>
        );
      },
    },
    {
      title: '設定値',
      dataIndex: 'flag',
      align: 'left' as 'left',
      render: (value: string, row: Model.CommonSettingRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.MUTUAL_AID_PROJECT_GIVING_POINT_METHOD, row.value)}
            </span>
          </>
        );
      },
    },
  ];


  /**
   * 役割別権限の表示
   */
  const positionAuthorityTableColumns = [
    {
      title: '役割',
      dataIndex: 'positioin',
      width: '250px',
      align: 'center' as 'center',
      render: (value: string, row: Model.PositionAuthority) => {
        return (
          <>
            <span>{constantsUtils.getLabelOf(CONSTANTS.POSITION_TYPE, row.positionType)}</span>
          </>
        );
      },
    },
    {
      title: '権限',
      dataIndex: 'authority',
      align: 'left' as 'left',
      render: (value: string, row: Model.PositionAuthority) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.POSITION_AUTHORITY_TYPE, row.positionAuthority)}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * メール送信可否設定
   */
  const mailTypeSendFlagTableColumns = [
    {
      title: 'メール通知タイミング',
      dataIndex: 'positioin',
      width: '250px',
      align: 'left' as 'left',
      render: (value: string, row: Model.MailTypeSendFlagRow) => {
        return (
          <>
            <span>{constantsUtils.getLabelOf(CONSTANTS.MAIL_TYPE, row.mailTypeCode)}</span>
          </>
        );
      },
    },
    {
      title: '通知設定',
      dataIndex: 'authority',
      align: 'left' as 'left',
      render: (value: string, row: Model.MailTypeSendFlagRow) => {
        return (
          <>
            <span>
              {constantsUtils.getLabelOf(CONSTANTS.MAIL_SEND_FLAG, row.flag)}
            </span>
          </>
        );
      },
    },
  ];

  /**
   * フッターボタンエリアの描画
   * @returns 
   */
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"編集"}
          size={"large"}
          shape={"round"}
          onClick={editClicked}
          className={AuthButtonStyles.authButtonFixed}
        />
      </FooterButtonArea>
    );
  }

  return (
    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        <CommonMessage />
        <div className={styles.settings}>

          <div className={styles.headline}>
            <span>【協力会社】勤怠提出を行う協力会社の設定</span>
          </div>
          <div className={styles.description}>
            選択条件に該当する協力会社のみが、勤怠提出を行えます。
          </div>
          <Table
            columns={submitLevelTypeColumns}
            size='small'
            dataSource={submitLevelTypeList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>締切設定</span>
          </div>
          <Table
            columns={closingDateTableColumns}
            size='small'
            dataSource={closingDateList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>【協力会社】協力会社側での勤怠編集可否の設定</span>
          </div>
          <div className={styles.description}>
          不可を選択すると、協力会社側で労働時間の編集ができなくなります。
          </div>
          <Table
            columns={editabilityWorkTimeColumns}
            size='small'
            dataSource={editabilityWorkTimeTypeList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>協力会社からの提出勤怠の「確認」要否設定</span>
          </div>
          <div className={styles.description}>
            協力会社から提出された勤怠の「承認」前に「確認」を必要とするかの設定です。設定した場合、「承認」前に「確認」が必要になります。
          </div>
          <Table
            columns={workflowColumns}
            size='small'
            dataSource={workflowFlagList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>【協力会社】入退場いずれかの記録のみの場合に労働時間の自動入力の利用設定</span>
          </div>
          <div className={styles.description}>
          「利用する」を選択の場合、協力会社側で認定技能者の勤怠を確認する際、入退場いずれかの記録がある作業日に労働時間８時間が自動入力されます。
          </div>
          <Table
            columns={calcWorkTimeColumns}
            size='small'
            dataSource={calcWorkTimeTypeList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>同一現場且つ複数編成下での入退場記録の表示設定</span>
          </div>
          <div className={styles.description}>
          協力会社が勤怠を入力する際の「同一現場且つ複数編成下での入退場記録」の表示方法を選択します。
          </div>
          <Table
            columns={attendancePerformanceDuplicateColumns}
            size='small'
            dataSource={attendancePerformanceDuplicateList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          {
            loginUserInfo.isMutualAidAvailableUserFlag === "1" ?
              <>
                <div className={styles.headline}>
                  <span>建退共連携時の同日複数現場の勤怠集約設定</span>
                </div>
                <div className={styles.description}>
                複数の工事現場で、同一の技能者が同じ日に勤務した場合に、建退共へ連携する勤怠を1日分にまとめるかを設定します。
                </div>
                <Table
                  columns={mutualAidProjectGivingPointMethodColumns}
                  size='small'
                  dataSource={mutualAidProjectGivingPointMethodList}
                  pagination={false}
                  className="hoverNotBackground"
                  style={{ marginLeft: "20px" }}
                  bordered
                />
              </>
              : <></>
          }

          <div className={styles.headline}>
            <span>プロジェクト毎の手当金額の算出方法</span>
          </div>
          <Table
            columns={apportionmentTypeColumns}
            size='small'
            dataSource={apportionmentTypeList}
            pagination={false}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>役割別権限</span>
          </div>
          <Table
            columns={positionAuthorityTableColumns}
            size='small'
            dataSource={storedPositionAuthorityList}
            pagination={false}
            scroll={{ x: 1000 }}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>【元請会社】勤怠承認権限を持つ本社/支店担当者へのメール通知設定</span>
          </div>
          <div className={styles.description}>
            元請会社の本社/支店担当者で勤怠承認者の権限を持つユーザーを対象に、担当下の協力会社から提出された勤怠が処理された際のメール通知の設定です。
          </div>
          <Table
            columns={mailTypeSendFlagTableColumns}
            size='small'
            dataSource={storedMailTypeSendFlagToPrimeSkillmapAuthorityApproveUserList}
            pagination={false}
            scroll={{ x: 1000 }}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />
          <div className={styles.headline}>
            <span>【元請会社】勤怠確認権限を持つ現場担当者へのメール通知設定</span>
          </div>
          <div className={styles.description}>
            元請会社の現場担当者で勤怠の確認権限を持つユーザーを対象に、担当下の協力会社から提出された勤怠が処理された際のメール通知の設定です。
          </div>
          <Table
            columns={mailTypeSendFlagTableColumns}
            size='small'
            dataSource={storedMailTypeSendFlagToPrimePositionAuthorityConfirmUserList}
            pagination={false}
            scroll={{ x: 1000 }}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />
          <div className={styles.headline}>
            <span>【元請会社】勤怠承認権限を持つ現場担当者へのメール通知設定</span>
          </div>
          <div className={styles.description}>
            元請会社の現場担当者で勤怠の承認権限を持つユーザーを対象に、担当下の協力会社から提出された勤怠が処理された際のメール通知の設定です。
          </div>
          <Table
            columns={mailTypeSendFlagTableColumns}
            size='small'
            dataSource={storedMailTypeSendFlagToPrimePositionAuthorityApproveUserList}
            pagination={false}
            scroll={{ x: 1000 }}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

          <div className={styles.headline}>
            <span>【協力会社】勤怠を提出したユーザーへのメール通知設定</span>
          </div>
          <div className={styles.description}>
            協力会社の勤怠を提出したユーザーを対象に、元請会社へ提出した勤怠が元請会社側で処理された際のメール通知の設定です。
          </div>
          <Table
            columns={mailTypeSendFlagTableColumns}
            size='small'
            dataSource={storedMailTypeSendFlagToPartnerSubmitUserList}
            pagination={false}
            scroll={{ x: 1000 }}
            className="hoverNotBackground"
            style={{ marginLeft: "20px" }}
            bordered
          />

        </div>
      </Content>
      <ButtonArea />
      <Footer />
    </Layout >
  );

}